/**
 * Das gerade gewählte Projekt.
 *
 * Songs, Setlists und Notizen hängen immer an einem Projekt. Diese Datei
 * beantwortet die Frage "an welchem gerade?" an einer Stelle, damit jede
 * Ansicht dieselbe Antwort bekommt.
 */
import type { Project } from '../types.ts';
import { ensureProjects, getSettings, saveSettings } from './repo.ts';

/**
 * Zuletzt ermitteltes Projekt. Der Rahmen zeigt seinen Namen in der
 * Seitenleiste, ohne dafür bei jedem Aufbau die Datenbank zu befragen.
 */
let cached: Project | null = null;

export function cachedProject(): Project | null {
  return cached;
}

/**
 * Liefert das aktive Projekt.
 * null bedeutet: es gibt noch gar keines, die Ansicht soll ins Regal schicken.
 */
export async function activeProject(): Promise<Project | null> {
  const projects = await ensureProjects();
  if (projects.length === 0) {
    cached = null;
    return null;
  }

  const settings = await getSettings();
  const chosen = settings.activeProjectId
    ? projects.find((project) => project.id === settings.activeProjectId)
    : undefined;
  if (chosen) {
    cached = chosen;
    return chosen;
  }

  // Nichts gewählt oder das gewählte ist weg: das erste nehmen und merken,
  // damit die App nie in einer Sackgasse landet.
  const first = projects[0] as Project;
  await saveSettings({ ...settings, activeProjectId: first.id });
  cached = first;
  return first;
}
